export const FIREBASE_AUTH_MODE = "firebase-v1";
export const AUTH_MODE_STORAGE_KEY = "myaccountAuthMode";

export const isFirebaseAuthMode = () =>
  window.localStorage.getItem(AUTH_MODE_STORAGE_KEY) === FIREBASE_AUTH_MODE;

export const enableFirebaseAuthMode = () => {
  window.localStorage.setItem(AUTH_MODE_STORAGE_KEY, FIREBASE_AUTH_MODE);
};
